<template>
  <td
    class="border-left-right"
    :class="calculateBackGroundColor"
  >
    <Modal
      v-if="selected != null"
      :open="true"
      :title="trans('subscription.classification_config.selector_builder')"
      @close="closeModal()"
    >
      <SelectorBuilder
        :selected-selector="selected"
        :selector-context="selectorContext"
        :program-id="programId"
        @SaveSelector="update"
        @RemoveSelector="remove"
      />
    </Modal>
    <button
      :disabled="isLoading"
      type="button"
      role="button"
      class="btn selector-button text-center rounded turn-off-button-styling"
      @click="select()"
    >
      <span
        v-if="calculateBackGroundColor === 'contains-selector'"
        class="fa fa-align-justify"
      />
      <span
        v-else-if="calculateBackGroundColor === 'no-selector'"
        class="fa fa-plus"
      />
    </button>
  </td>
</template>

<script>
import Modal from '@/employees/AttendanceList/components/Modal'
import SelectorBuilder from '@/employees/components/Selector/utilities/SelectorBuilder'
import _cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'SelectorCell',
  inject: ['selectorContext', 'programId'],
  components: {
    Modal,
    SelectorBuilder,
  },
  props: {
    value: {
      required: true,
      type: Object,
    },
    isLoading: {
      required: true,
      type: Boolean,
    },
  },
  data () {
    return {
      selected: null,
    }
  },
  computed: {
    calculateBackGroundColor () {
      if (!this.value.selector) {
        return 'no-selector'
      }
      return 'contains-selector'
    },
  },
  methods: {
    update ({ selector }) {
      const cloneSelector = _cloneDeep(this.value)
      cloneSelector.selector = selector
      this.$emit('input', cloneSelector)
      this.selected = null
    },
    remove () {
      const cloneSelector = _cloneDeep(this.value)
      cloneSelector.selector = null
      this.$emit('input', cloneSelector)
      this.selected = null
    },
    select () {
      this.selected = this.value
    },
    closeModal () {
      this.selected = null
    },
  },
}
</script>

<style scoped>
.no-selector {
  background-color: #d3d3d3ad;
}
.selector-button {
  width: 95%;
  border: 2px #ffffff00 solid;
}
.selector-button:focus {
  border: 2px black solid;
}
.selector-button:disabled {
  border: transparent;
  background-color: rgba(0, 0, 0, 0.3);
}
.turn-off-button-styling {
  background: transparent !important;
  background-color: none !important;
  color: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>
